/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

//img
import edit_logo from "../../../../icons/edit.png";
import tash_logo from "../../../../icons/trash.png";
import constants from "../../../../utils/constants";

//Childs
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "../../../Common/Dropdown";
import { getArtPackById } from "../../../../utils/services";
import { useGlobal } from "../../../../context/GlobalContextProvider";
import { useWallet } from "../../../../context/WalletContextProvider";

export default function Selector({
  data,
  onEdit,
  onDelete,
}) {
  const navigate = useNavigate();
  const { account } = useWallet();
  const { campaign, setCampaign, setArtPack } = useGlobal();
  const [copied, setCopied] = useState(false);
  //Status errors
  const [errorCampaignName, setErrorCampaignName] = useState(false);

  const handleChange = (campaign) => {
    setCampaign(campaign);
    setArtPack(null)
  };

  const continueNext = async () => {
    //error campaign name
    if (Number(campaign?.campaign_id) > 0) {
      setErrorCampaignName(false);
      sessionStorage.setItem(constants.CAMPAIGN_IDENTIFIER, campaign?.campaign_id);
      sessionStorage.setItem(
        constants.ART_PACK_IDENTIFIER, campaign?.art_pack_id
      );
      const artPackData = await getArtPackById(account, campaign?.art_pack_id);
      setArtPack(artPackData);
      navigate(`${constants.SPONSOR_BASE_PATH}/background-price`);
    } else {
      setErrorCampaignName(true);
    } 
  };

  const showEditOrDelete = () => {
    if(data?.length === 0) return <div className="col-sm-2 align-self-start ps-4 pt-1" />;
    return (
      <div className="col-sm-2 align-self-start ps-4 pt-1">
        <a
          onClick={(e) => {
            if (campaign?.sc_id) {
              alert("You cannot edit this campaign because it is already launched, but you can see all the data you’ve filled.");
            }
            onEdit(campaign?.campaign_id)
          }}
          style={{
            cursor: "pointer"
          }}
        >
          <img className="edit-delete-icons" src={edit_logo} alt="Edit" />
        </a>
        <a
          onClick={(e) =>
            campaign?.sc_id ? e.preventDefault() : onDelete(campaign?.campaign_id)
          }
          style={{
            cursor: campaign?.sc_id
              ? "not-allowed"
              : "pointer"
          }}
        >
          <img
            className="edit-delete-icons ms-3"
            src={tash_logo}
            alt="Delete"
          />
        </a>
      </div >
    );
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(campaign?.public_id);
      setCopied(true);
      requestAnimationFrame(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };


  return (
    <>
      <label htmlFor="campaign_id" className="mb-2 form-labels">
        Campaign Website
      </label>
      <div className="col-sm-12 d-flex justify-content-center">
        <div style={{ width: "95%" }}>
          <Dropdown
            category="campaign"
            categorySubType="main"
            dropdownList={data}
            handleChange={handleChange}
            dropdownHeader={
              campaign?.campaign_name || "Choose a website"
            }
          />
        </div>
        {showEditOrDelete()}
      </div>

      {errorCampaignName ? (
        <span id="errorCampaignName" className="form-text text-danger">
          Choose an option!
        </span>
      ) : (
        <span></span>
      )}

      {campaign?.campaign_id > 0 && (
        <span
          className={`form-text ${!campaign?.sc_id ? "text-danger" : "text-success"}`}
        >
          {!campaign?.sc_id
            ? `Campaign not built yet`
            : "Campaign already built"}
        </span>
      )}

      {campaign?.public_id && (
        <div>
          <label className="mb-2 form-labels project-code">
            Project Code : {campaign?.public_id}
          </label>
          {!copied ? (
            <div className="project-code-copy" onClick={copyToClipboard}>
              <FontAwesomeIcon
                icon="fa-solid fa-copy"
                size="xl"
                color="#949494"
              />
              <span className="project-code-copy-status">Copy</span>
            </div>
          ) : (
            <div className="project-code-copy">
              <FontAwesomeIcon
                icon="fa-solid fa-check"
                size="xl"
                color="#949494"
              />
              <span className="project-code-copy-status">Copied!</span>
            </div>
          )}
        </div>
      )}

      <div className="mt-5">
        <a onClick={continueNext} className="btn bg-orange form-btn">
          Click to continue
        </a>
      </div>
    </>
  );
}
